var map = {
	"./gol10_1_orig.jpeg": 6651,
	"./gol11_1_orig.jpeg": 2842,
	"./gol12_1_orig.jpeg": 4300,
	"./gol1_1_orig.jpeg": 2560,
	"./gol2_1_orig.jpeg": 2437,
	"./gol3_1_orig.jpeg": 1682,
	"./gol4_1_orig.jpeg": 673,
	"./gol5_1_orig.jpeg": 6114,
	"./gol6_1_orig.jpeg": 5343,
	"./gol7_1_orig.jpeg": 67,
	"./gol8_1_orig.jpeg": 7357,
	"./gol9_1_orig.jpeg": 5536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2793;